<script>
export default {
    name: "FloorEditForm",

    data() {

        return {
            errors: []
        };
    },

    props: {
        floor: Object,
        showModal: Boolean,
    },

    methods: {

        updateData() {

            this.$root.loading = true;
            this.$http.post(`MasterData/Floors`, this.floor).then(response => {
                this.$emit(`refresh`);
                this.$root.loading = false;
                this.$emit(`closeModal`);
                window.Swal.fire({type: 'success', title: response.data});
            }).catch(() => { this.$root.loading = false; this.$emit(`closeModal`); });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="w-8/12 h-auto">
      <template v-slot:title>
        <h5 class="text-sm font-medium">Edit Floor</h5>
      </template>
      <template v-slot:modal-body>
            <div class="flex flex-wrap -m-4">
                <div class="w-1/3 p-2">
                    <label for="grid-name" class="label-control">Floor:</label>
                    <input type="text" id="grid-name" v-model.trim="floor.floor" class="input-control input-sm text-xs">
                    <p class="form-text-error" v-if="errors.filter(error => error.field == 'floor').length">
                        {{ errors.filter(error => error.field == 'floor')[0].message }}</p>
                </div>
                <div class="w-1/3 p-2">
                    <label for="grid-description" class="label-control">Description:</label>
                    <textarea id="grid-description" v-model.trim="floor.description" cols="3" rows="1" class="input-control input-sm text-xs"></textarea>
                </div>
                <div class="w-1/6 p-2 pt-4">
                    <label for="grid-status" class="label-control mt-4">Active <input type="checkbox" id="grid-status" v-model="floor.active"></label>
                </div>
            </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs rounded mr-6" @click="$emit(`closeModal`)"><i class="fa fa-times"></i> Cancel</button>
        <button class="btn-primary btn-sm text-xs rounded" @click.prevent="updateData"><i class="fa fa-save"></i> Update</button>
      </template>
    </tail-modal>
</template>

